// src/Dashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const studentData = JSON.parse(localStorage.getItem('studentData'));

  const handleLogout = () => {
    localStorage.removeItem('studentToken');
    localStorage.removeItem('studentData');
    navigate('/');
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Welcome, {studentData?.first_name} {studentData?.surname}</h1>
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </header>
      
      <main className="dashboard-main">
        <div className="dashboard-card">
          <h2>Student Dashboard</h2>
          <p>We'll implement the full dashboard based on your requirements.</p>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;